// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.summary .info {
  padding: var(--spacing) 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.summary .info .full-width {
  width: 100%;
}
.summary .actions {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-quarter);
  padding-bottom: var(--spacing-quarter);
}
.summary .actions .commission {
  margin-bottom: var(--spacing-quarter);
}

.feedback {
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--ion-background-color);
  text-align: center;
  padding: var(--spacing-double);
}
.feedback .button {
  margin-top: var(--spacing);
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/booking-summary/booking-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AACJ;AACI;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACR;AACQ;EACI,WAAA;AACZ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;AADR;AAGQ;EACI,qCAAA;AADZ;;AAOA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,8BAAA;AAJJ;AAMI;EACI,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAJR","sourcesContent":[".summary {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n\n    .info {\n        padding: var(--spacing) 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .full-width {\n            width: 100%;\n        }\n    }\n\n    .actions {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing-quarter);\n        padding-bottom: var(--spacing-quarter);\n\n        .commission {\n            margin-bottom: var(--spacing-quarter);\n        }\n    }\n}\n\n\n.feedback {\n    position: absolute;\n    z-index: 2;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--ion-background-color);\n    text-align: center;\n    padding: var(--spacing-double);\n\n    .button {\n        margin-top: var(--spacing);\n        max-width: 200px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
